export class Backup {

  public id: string;
  public jobName: string;
  public date: Date;
  public file: string;
  public destination: string;
  public folder: string;
  public size: number;
  public jid: number;
  public checkpoints: any;
}
